<template>
  <div
    v-if="tooltip.visible"
    class="interactive-tooltip"
    :style="tooltip.style"
    :class="tooltip.classes"
    id="tooltip"
  >
    <slot name="header"> </slot>
    <template v-if="tooltip.type == 'default'">
      <slot name="default-content"></slot>
    </template>
    <template v-else-if="tooltip.type == 'custom'">
      <slot name="custom-content">
        <div
          class="interactive-tooltip-custom-content vueberg-content"
          v-html="tooltip.content"
        ></div>
      </slot>
    </template>
    <slot name="footer"> </slot>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  data() {
    return {};
  },
  props: ["tooltip"],
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped></style>
